import * as React from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../store';
import { getActiveAIOperationFromState } from '../../../store/StateControllers/Survey/SurveyResponse/AISurveyAgentController';
import { DataCollectionAiAgentOperationType } from '../../../store/StateControllers/Survey/SurveyResponse/SurveyResponseModels';
import { IStringLocalizer } from '../../../utilities/IStringLocalizer';
import { formatTimestampForDisplay } from './dateTimeUtils';
import { useLocalizer } from './hooks/useLocalizer';

interface AILastUpdatedTimeProps {
    localizer: IStringLocalizer;
    operationType?: DataCollectionAiAgentOperationType | null;
}

export const AILastUpdatedTime: React.FC<AILastUpdatedTimeProps> = ({
    localizer,
    operationType
}) => {
    const localize = useLocalizer(localizer);
    const aiOperation = useSelector((state: ApplicationState) =>
        getActiveAIOperationFromState(state.aiSurveyAgentState, operationType)
    );
    const aiLastPolledAt = useSelector((state: ApplicationState) =>
        state.aiSurveyAgentState?.lastPolledAt
    );

    const formattedTimestamp = React.useMemo(() => {
        const timestamp = aiOperation ? (aiOperation.dateModified ?? aiLastPolledAt ?? null) : null;
        return formatTimestampForDisplay(timestamp);
    }, [aiOperation?.dateModified, aiLastPolledAt]);

    if (!formattedTimestamp) {
        return null;
    }

    return (
        <p className="ai-agent-last-updated" aria-live="polite">
            <span className="ai-agent-last-updated-label">{localize("Last Updated (UTC)")}:</span> {formattedTimestamp}
        </p>
    );
};

export default AILastUpdatedTime;
